import { createPortal } from 'react-dom';
import { StyledToastContainer } from './styled';
import Toast from '../Toast';

const ToastContainer = ({ toasts }) => {
  if (toasts.length !== 0) {
    return createPortal(
      <StyledToastContainer>
        {toasts.map((props) => (
          <Toast hasKey {...props} />
        ))}
      </StyledToastContainer>,
      document.body
    );
  }

  return null;
};

export default ToastContainer;
